import {
  type MediaAsset,
  canUseMediaOriginalAsPreviewFallback,
} from './media-asset';
import { MEDIA_DERIVATIVE_POLICY_VERSION } from './media-task';

const LEGACY_MEDIA_DERIVATIVE_POLICY_VERSION = 1;

export function resolveMediaAssetDerivativePolicyVersion(asset: MediaAsset) {
  return (
    asset.derivativePolicyVersion ?? LEGACY_MEDIA_DERIVATIVE_POLICY_VERSION
  );
}

export function isMediaAssetDerivativePolicyCurrent(
  asset: MediaAsset,
  currentPolicyVersion: number = MEDIA_DERIVATIVE_POLICY_VERSION
) {
  return (
    resolveMediaAssetDerivativePolicyVersion(asset) >= currentPolicyVersion
  );
}

export function requiresMediaAssetDerivativeProcessing(asset: MediaAsset) {
  if (asset.kind === 'video') return true;
  return !canUseMediaOriginalAsPreviewFallback(asset);
}
